import styles from 'css/src/components/app/recorder/RetakeOverlay.module.scss';

import React from 'react';
import classNames from 'classnames';

import Button, { BUTTON_COLORS } from 'js/src/components/common/ui/Button';

type RetakeOverlayProps = {
    show: boolean;
    onRetake: () => void;
    onCancel: () => void;
    containerClasses?: string;
};

const RetakeOverlay: React.FC<RetakeOverlayProps> = React.memo(function RetakeOverlay({
    show,
    onRetake,
    onCancel,
    containerClasses,
}) {
    return (
        <>
            {show && (
                <div
                    className={classNames(
                        styles['retake-overlay'],
                        'd-flex justify-content-center align-items-center',
                        containerClasses,
                    )}
                >
                    <div className={styles['foreground']}>
                        <h4>You will lose this recording if you retake.</h4>
                        <div className="mt-l5-16 d-flex justify-content-center">
                            <Button
                                text="Cancel"
                                onClick={onCancel}
                                color={BUTTON_COLORS.SIMPLE}
                                className="me-l5-16 text-white"
                            />
                            <Button text="Retake" color={BUTTON_COLORS.DANGER} onClick={onRetake} />
                        </div>
                    </div>
                </div>
            )}
        </>
    );
});

export default RetakeOverlay;
